/**
 * Map backend user fields → app shell role used for permissions / admin chrome.
 * Prefer explicit API role / superuser over demo-name heuristics.
 */

export interface RoleSourceUser {
  username?: string | null;
  full_name?: string | null;
  role?: string | null;
  is_superuser?: boolean | null;
}

const DEMO_ROLE_BY_USERNAME: Record<string, string> = {
  demo_user: 'demo',
};

export function resolveAppUserRole(apiUser: RoleSourceUser): string {
  const username = (apiUser.username ?? '').toLowerCase();
  const fullName = apiUser.full_name ?? '';

  if (apiUser.is_superuser) {
    return 'superuser';
  }

  const apiRole = (apiUser.role ?? '').trim().toLowerCase().replace(/-/g, '_');
  if (apiRole === 'platform_admin') {
    return 'platform_admin';
  }
  if (apiRole === 'superuser' || apiRole === 'admin' || apiRole === 'administrator') {
    return apiRole === 'administrator' ? 'admin' : apiRole;
  }
  if (
    apiRole === 'architect' ||
    apiRole === 'operator' ||
    apiRole === 'coach' ||
    apiRole === 'manager' ||
    apiRole === 'viewer' ||
    apiRole === 'demo' ||
    apiRole === 'user'
  ) {
    return apiRole;
  }

  if (username && DEMO_ROLE_BY_USERNAME[username]) {
    return DEMO_ROLE_BY_USERNAME[username];
  }
  if (fullName.includes('Alex') || username.includes('alex')) return 'operator';
  if (fullName.includes('Sarah') || username.includes('sarah')) return 'coach';
  if (fullName.includes('Mike') || username.includes('mike')) return 'architect';

  return apiRole || 'user';
}
